module.exports = __webpack_public_path__ + "img/aqua1.9cf3b0bb.png";